export default "__VITE_ASSET__54c64c93__"